<template>
  <div class="justify-start d-flex d-flex-row align-start">
    <v-avatar
      rounded="full"
      :size="$vuetify.breakpoint.smAndDown ? 50 : 80"
      left
      class="mr-4"
      color="primary"
    >
      <v-img
        v-if="comment.user.image"
        :src="comment.user.image"
        :alt="comment.user.name"
        :lazy-src="require('@/assets/img/logo.png')"
        eager
      />
      <p v-else class="white--text text-h3 font-weight-semibold ma-auto">
        {{ userInitial }}
      </p>
    </v-avatar>
    <v-card outlined width="100%" class="pa-2" rounded="lg">
      <v-card-text class="flex-row text-subtitle-2 d-flex">
        {{ comment.user.name }} ● {{ showElapedTime }}
        <v-spacer />
        <span
          class="flex-row d-flex align-center justify-space-between"
          v-if="showEditDelete"
        >
          <v-btn
            icon
            v-show="!showEditor"
            @click="deleteComment"
            :loading="deleteLoading"
            :disabled="editLoading"
          >
            <v-icon>delete</v-icon>
          </v-btn>

          <v-btn v-if="!showEditor" icon class="mx-2" @click="toggleEdit">
            <v-icon>edit</v-icon>
          </v-btn>
        </span>
      </v-card-text>
      <v-card-subtitle
        class="flex-row justify-start black--text text-subtitle-1 mt-n4"
      >
        <Editor
          v-if="showEditor"
          ref="editor"
          :isEditable="showEditor"
          :content="editorContent"
        />
        <span v-else v-html="comment.body"></span>
      </v-card-subtitle>
      <v-card-actions v-if="isUserLoggedIn">
        <v-btn
          icon
          @click="toggleLike"
          :color="didCurrentUserLiked ? 'primary' : 'grey'"
        >
          <v-icon>{{
            didCurrentUserLiked ? 'favorite' : 'favorite_border'
          }}</v-icon>
        </v-btn>
        <span class="mx-1" v-if="comment.likes.length > 0">{{
          comment.likes.length
        }}</span>
        <v-spacer />
        <span v-if="showEditor">
          <v-btn class="rounded-lg" outlined @click="toggleEdit">CANCEL</v-btn>
          <v-btn
            color="success"
            class="mx-2 rounded-lg"
            depressed
            @click="editComment"
            :loading="editLoading"
            :disabled="deleteLoading"
          >
            DONE
          </v-btn>
        </span>
        <span v-else>
          <v-tooltip top>
            <template v-slot:activator="{on, attrs}">
              <v-btn icon @click="toggleReport" color="grey" v-on="on" v-bind="attrs">
                <v-icon>report</v-icon>
              </v-btn>
            </template>
            <span>Report Comment</span>
          </v-tooltip>
        </span>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { formatToElapsedTime } from '@/utils/date'
import Editor from '@/components/ViewForum/Editor.vue'
import cleanCommentBody from '@/services/cleanCommentBody'

export default {
  name: 'Comment',
  components: { Editor },
  props: ['comment'],
  data: () => ({
    showEditor: false,
    editorContent: null,
    editLoading: false,
    deleteLoading: false
  }),
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['users/AUTH_USER']
    },
    userInitial() {
      const user = this.$store.getters['users/USER']
      if (!user.name) {
        return '0'
      }

      return user.name.split(' ')[0].at(0)
    },
    showEditDelete() {
      const user = this.$store.getters['users/USER']
      return user.id === this.comment.uid || user.role === 'admin'
    },
    didCurrentUserLiked() {
      const user = this.$store.getters['users/USER']
      return this.comment.likes.includes(user.id)
    },
    showElapedTime() {
      return formatToElapsedTime(this.comment.date)
    }
  },
  methods: {
    toggleEdit() {
      this.editorContent = this.comment.body
      this.showEditor = !this.showEditor
    },
    async deleteComment() {
      const response = await this.$swal.fire({
        title: 'Delete this comment?',
        text: 'Are you sure you want to delete this comment?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No'
      })

      if (!response.value) {
        return
      }

      this.isDeleteLoading = true
      await this.$store.dispatch('comments/DELETE_COMMENT', {
        id: this.comment.id
      })
      this.isDeleteLoading = false
    },
    async editComment() {
      const content = this.$refs.editor.getContent()
      const cleanedContent = await cleanCommentBody(content)
      this.editLoading = true
      await this.$store.dispatch('comments/UPDATE_COMMENT', {
        id: this.comment.id,
        body: cleanedContent
      })
      this.editLoading = false
      this.$refs.editor.clearContent()
      this.showEditor = false
    },
    async toggleLike() {
      await this.$store.dispatch('comments/TOGGLE_LIKE', {
        id: this.comment.id
      })
    },
    toggleReport() {
      this.$emit("toggleReport", this.comment.id);
    }
  }
}
</script>

<style></style>
